import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-size-14 text-font-inter text-dark-blue-gray-brain font-weight-500 p-col-12" }
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = { class: "p-grid p-col-6" }
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Nombre de Unidad", -1)
const _hoisted_6 = { class: "p-col-12 p-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Descripcion corta", -1)
const _hoisted_8 = { class: "p-grid p-col-6 p-ml-4" }
const _hoisted_9 = { class: "p-col-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Seleccione las clases para la unidad", -1)
const _hoisted_12 = ["for"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Contenido", -1)
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "p-d-flex p-jc-end" }
const _hoisted_17 = {
  key: 0,
  class: "p-mr-4"
}
const _hoisted_18 = {
  key: 1,
  class: "p-mr-4"
}
const _hoisted_19 = {
  key: 2,
  class: "p-mr-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("h5", _hoisted_1, "Unidades " + _toDisplayString(_ctx.index+1), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Textarea, {
              type: "text",
              modelValue: _ctx.unitData.unitName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.unitData.unitName = $event)),
              rows: "1",
              cols: "100",
              autoResize: true,
              disabled: _ctx.editingUnitId !== _ctx.unitData.id
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Textarea, {
              id: "description",
              type: "text",
              modelValue: _ctx.unitData.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.unitData.description = $event)),
              rows: "4",
              cols: "100",
              autoResize: true,
              disabled: _ctx.editingUnitId !== _ctx.unitData.id
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.editingUnitId === _ctx.unitData.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  (!_ctx.classesPlan)
                    ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classesPlan, (clazz) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: clazz.id,
                      class: "field-checkbox p-pt-2 p-pl-2"
                    }, [
                      _createVNode(_component_Checkbox, {
                        id: clazz.id,
                        name: "clazz",
                        value: clazz,
                        modelValue: _ctx.selectedClasses,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedClasses = $event)),
                        disabled: _ctx.isDisabled(clazz)
                      }, null, 8, ["id", "value", "modelValue", "disabled"]),
                      _createElementVNode("label", {
                        class: "p-pl-2",
                        for: clazz.id
                      }, _toDisplayString(clazz.name), 9, _hoisted_12)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.editingUnitId !== _ctx.unitData.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  (!_ctx.classesPlan)
                    ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedClasses, (clazz) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: clazz.id,
                      class: "field-checkbox p-pt-2 p-pl-2"
                    }, [
                      _createVNode(_component_Checkbox, {
                        id: clazz.id,
                        name: "clazz",
                        value: clazz,
                        modelValue: _ctx.selectedClasses,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedClasses = $event)),
                        disabled: true
                      }, null, 8, ["id", "value", "modelValue"]),
                      _createElementVNode("label", {
                        class: "p-pl-2",
                        for: clazz.id
                      }, _toDisplayString(clazz.name), 9, _hoisted_15)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_ctx.editingUnitId === _ctx.unitData.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_Button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save())),
                class: "p-button-primary p-button-outlined",
                label: "Guardar",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.editingUnitId === _ctx.unitData.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_Button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteUnit())),
                class: "p-button-danger p-button-outlined",
                label: "Eliminar",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.editingUnitId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_Button, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.edit())),
                class: "p-button-primary p-button-outlined",
                label: "Editar unidad",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}